/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AgencyEmployeeResource
 */
export interface AgencyEmployeeResource {
    /**
     * 
     * @type {string}
     * @memberof AgencyEmployeeResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyEmployeeResource
     */
    agencyId: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyEmployeeResource
     */
    firstname: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyEmployeeResource
     */
    lastname: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyEmployeeResource
     */
    externalId?: string;
}

/**
 * Check if a given object implements the AgencyEmployeeResource interface.
 */
export function instanceOfAgencyEmployeeResource(value: object): value is AgencyEmployeeResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('agencyId' in value) || value['agencyId'] === undefined) return false;
    if (!('firstname' in value) || value['firstname'] === undefined) return false;
    if (!('lastname' in value) || value['lastname'] === undefined) return false;
    return true;
}

export function AgencyEmployeeResourceFromJSON(json: any): AgencyEmployeeResource {
    return AgencyEmployeeResourceFromJSONTyped(json, false);
}

export function AgencyEmployeeResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyEmployeeResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'agencyId': json['agencyId'],
        'firstname': json['firstname'],
        'lastname': json['lastname'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
    };
}

export function AgencyEmployeeResourceToJSON(value?: AgencyEmployeeResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'agencyId': value['agencyId'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'externalId': value['externalId'],
    };
}

